import React, { useEffect, useState, useRef } from 'react';
import Highcharts from 'highcharts';
import { CAMPAING_PROMISE_TYPES, PRODUCT_TYPES } from '../../../constants/enums';
import styles from './Regions.module.css';

const Regions = ({ orderlinesData, campaignPromiseType, campaignType, showDaysGraph, regionHeaderText, alignWithFooterNote }) => {
    const chartRef = useRef(null);
    const containerRef = useRef(null);
    const [graphValues, setGraphValues] = useState([]);
    const [yLabel, setYLabel] = useState('');

    useEffect(() => {
        if (orderlinesData) {
            switch (campaignType) {
                case PRODUCT_TYPES.PLAY:
                    switch (campaignPromiseType) {
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:                            
                            if (orderlinesData.playData.spotlengths &&
                                orderlinesData.playData.useAlternateContacts &&
                                orderlinesData.playData.spotlengths.length === 1 &&
                                orderlinesData.playData.spotlengths[0] === 10) {
                                setGraphValues(orderlinesData.playData.alternateContacts.regions);
                            } else {
                                setGraphValues(orderlinesData.playData.contacts.regions);
                            }
                            break;
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:                             
                            if (orderlinesData.playData.spotlengths &&
                                orderlinesData.playData.useAlternateContacts &&
                                orderlinesData.playData.spotlengths.length === 1 &&
                                orderlinesData.playData.spotlengths[0] === 5) {
                                setGraphValues(orderlinesData.playData.alternateContacts.regions);
                            } else {
                                setGraphValues(orderlinesData.playData.contacts.regions);
                            }
                            break;
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:                            
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0:                            
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
                        case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
                            setGraphValues(orderlinesData.playData.plays.regions)
                            break;
                        default:
                            console.error('campaignPromiseType in regions not mapped ' + campaignPromiseType);
                    }
                    break;
                case PRODUCT_TYPES.CLASSIC:
                    const postingData = [
                        ...orderlinesData.postingData.slice(0, orderlinesData.orderLineDataInformation.postingDataLength),
                        ...orderlinesData.podPostingData,
                    ];
                    switch (campaignPromiseType) {
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:                            
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0:                            
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:
                            const numWeeks = postingData.length;

                            const groupedRegions = postingData
                                .flatMap(posting => posting.podRegions)
                                .reduce((acc, region) => {
                                    const existingRegion = acc.find(item => item.name === region.name);

                                    const totalQuantity = region.classicScreensData.reduce((sum, screen) => sum + screen.quantity, 0);

                                    if (existingRegion) {
                                        existingRegion.value += region.value;
                                        existingRegion.screens += region.screens;
                                        existingRegion.vac += region.vac;
                                        existingRegion.classicScreensTotal += totalQuantity;
                                    } else {
                                        acc.push({
                                            ...region,
                                            classicScreensTotal: totalQuantity
                                        });
                                    }

                                    return acc;
                                }, [])
                                .map(env => ({
                                    ...env,
                                    classicScreens: parseFloat((env.classicScreensTotal / numWeeks).toFixed(1))
                                }));
                            setGraphValues(groupedRegions);
                            break;
                        default:
                            console.error('campaignPromiseType in regions not mapped');
                    }
                    break;
            }
        }

        switch (campaignPromiseType) {
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
                setYLabel('EA-VAC');
                break;
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:                                
                setYLabel('VAC');
                break;
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:
                setYLabel('VAC/VI');
                break;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:
            case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:                
                setYLabel('Panels');
                break;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0:
                setYLabel('Plays');
                break;
            default:
                setYLabel('Data'); // Fallback label
        }
    }, [orderlinesData, campaignPromiseType]);

    const getValue = (item) => {
        switch (campaignPromiseType) {
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:                
                return item.vac;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:                
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:                
                return item.delivered;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:             
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:                
                return item.delivered; // plays
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:
            case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:
                return item.screens;
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI://panels
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS://panels
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER://panels
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI://panels
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER://panels
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS://panels
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0://panels
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0://panels
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:                                
                return item.classicScreens;
            default:
                return item.value; // Fallback value
        }
    };

    useEffect(() => {
        if (graphValues.length > 0) {
            renderChart();
        }

        const handleResize = () => {
            if (chartRef.current) {
                chartRef.current.reflow();
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [graphValues]);

    const renderChart = () => {
        chartRef.current = Highcharts.chart(containerRef.current, {
            chart: {
                type: 'area',
            //    height: 200
            },
            credits: {
                enabled: false
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: graphValues.map((x) => x.name),
                tickWidth: 1,
                labels: {
                    style: {
                        fontFamily: "'BauerMediaSans', sans-serif"
                    },
                },
            },
            yAxis: {
                title: {
                    text: yLabel,
                    style: {
                        fontSize: '11px',
                        fontFamily: "'BauerMediaSans', sans-serif"
                    }
                },
                labels: {
                    formatter: function () {
                        return this.value
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    },
                    style: {
                        fontSize: '11px',
                        fontFamily: "'BauerMediaSans', sans-serif"
                    },
                },
                min: Math.min(...graphValues.map((x) => getValue(x))) * 0.75,
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    enableMouseTracking: true,
                    dataLabels: {
                        enabled: true,
                        overflow: 'allow',
                        crop: false,
                        style: {
                            fontWeight: 'normal',
                            fontSize: '11px',
                            fontFamily: "'BauerMediaSans', sans-serif"
                        },
                        formatter: function () {
                            return this.y
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                    },
                },
                area: {
                    fillOpacity: 1,
                    marker: {
                        enabled: false,
                    },
                },
            },
            tooltip: {
                enabled: true,
                formatter: function () {
                    const header = `${this.key}<br/>`;
                    const body = `<span style="font-family: 'BauerMediaSansBold', sans-serif;color:${this.color};">\u25CF</span> ${this.series.name}: <b>${this.y
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</b>`;
                    return header + body;
                },
                style: {
                    fontSize: '12px',
                    fontFamily: "'BauerMediaSans', sans-serif"
                }
            },
            series: [
                {
                    name: yLabel,
                    color: 'black',
                    type: 'column',
                    data: graphValues.map((x) => getValue(x)),
                },
            ],
        });
    };


    return (
        <div className={styles.chartShadow}>
            <div className={styles.graphLabel}>
                <h4>{regionHeaderText ?? "Regions"}</h4>
            </div>
            <div
                className={`
                    ${showDaysGraph ? styles.regGraph : styles.regGraphNoDays}
                    ${alignWithFooterNote ? styles.regGraphWithFootNote : ''}
                `}
                ref={containerRef} id="pod_region_container"></div>
        </div>);
};

export default Regions;
